"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _bbcode = require("./bbcode.0.4.0-bobtv");
var _app = _interopRequireDefault(require("../../app.config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var options = {};
var fontNames = _app["default"].font_names;
var fontFamilies = [];
if (fontNames) {
  var fontEntries = fontNames.split(";");
  for (var i = 0; i < fontEntries.length; i++) {
    var parts = fontEntries[i].split("/");
    var compressedFontFamily = parts[0].replace(/\s+/g, '');
    fontFamilies[compressedFontFamily] = parts[1];
  }
}
options.defaultFontFamily = _app["default"].default_font_family;
options.fontFamilies = fontFamilies;
options.currentNick = "";
function bbcodeRender(content, opts) {
  var real_options = _typeof(opts) == 'object' ? _objectSpread(_objectSpread({}, options), opts) : options;
  if (_typeof(opts) == 'object' && opts.extractAttachments) {
    return (0, _bbcode.render_and_extract_attachments)(content, real_options);
  } else {
    return (0, _bbcode.render)(content, real_options);
  }
}
var _default = bbcodeRender;
exports["default"] = _default;